export const translations_en = {
    password:"Password",
    mail:"Mail",
    users:"Users",
    importExcel:"Import excel file",
    totalNoOfUser:"Total number of users:",
    firstName:"First Name",
    lastName:"Last Name",
    Email:"Email ID",
    MobileNumber:"Mobile Number",
    deleteUser:"Delete user",
    addCategory:"Add a new category",
    categoryName:"Category Name",
    encouragingText:"Encouraging text",
    taskDeleted:"Task Deleted successfuly!",
    categories:"Categories",
    newCategory:"+ Add a new category",
    newQuiz:"+ Add a new quiz",
    edit:"Edit",
    delete:"Delete",
    cancel:"Cancel",
    deleteTasks:"Delete Tasks",
    backToTasks:"Back to Tasks",
    newTasks:"+ Add a new Task",
    totalTasks:"Total number of tasks:",
    taskName:"Task Name",
    ages:"Ages",
    category:"Category",
    quiz:"Quiz",
    attempts:"AVG num of attempts",
    addTask:"Add New Tasks",
    admins:"Admins",
    taskSuccess:"Task Added Successfully",
    description:"Description",
    size:"Team Size"
}